import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    list: new Map(),
    initialized: false
});

export default (env, state = INITIAL_STATE, action) => {
    switch (action.type) {
        case `${env.toUpperCase()}__SET_PRODUCTS`:
            return core.setProducts(state, action.products);
        case `${env.toUpperCase()}__UPDATE_PRODUCTS`:
            return core.updateProducts(state, action.products);
        case `${env.toUpperCase()}__UPDATE_HOME_PRODUCTS`:
            return core.updateProducts(state, action.products);
        case `${env.toUpperCase()}__SET_PRODUCT_DETAILS`:
            return core.setProductDetails(state, action.product);
        case `${env.toUpperCase()}__SET_NEW_PRODUCT_DETAILS`:
            return core.setNewProductDetails(state, action.product);
        case `${env.toUpperCase()}__PRODUCT_UPDATE_STATUS`:
            return core.setProductStatus(state, action.productKey, action.status);
        case `${env.toUpperCase()}__PRODUCT_UPDATE_FIELD`:
            return core.updateProductField(state, action.productKey, action.fieldName, action.fieldValue);
        case `${env.toUpperCase()}__PRODUCT_DISSOCIATE`:
            return core.dissociateProduct(state, action.productKey, action.fieldName, action.fieldValue);
        case `${env.toUpperCase()}__PRODUCT_MODULE_UPDATE`:
            return core.updateProductModule(state, action.productKey, action.productModuleKey, action.form);
        case `${env.toUpperCase()}__FHEPRODUCT_THRESHOLD_UPDATE`:
            return core.updateFheProductThreshold(state, action.productKey, action.productModuleKey, action.threshold);
        case `${env.toUpperCase()}__FHEPRODUCT_GAIN_UPDATE`:
            return core.updateFheProductGain(state, action.productKey, action.productModuleKey, action.gain);
        case `${env.toUpperCase()}__FHEPRODUCT_POLARITY_UPDATE`:
            return core.updateFheProductPolarity(state, action.productKey, action.productModuleKey, action.polarity);
        case `${env.toUpperCase()}__PRODUCT_DELETE`:
            return core.deleteProduct(state, action.productKey);
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Products/reducer.js